import {
  currencyFormatter4Digits,
  defaultDateFormatter,
  TableField,
} from "../../table-field";

const sequencial: TableField = {
  key: "NuSequencialLote",
  label: "#",
  tdClass: ["align-middle", "naoQuebrar", "text-center"],
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: false,
};
const descricao: TableField = {
  key: "DeLote",
  label: "Descrição",
  tdClass: "align-middle",
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const fracassado: TableField = {
  key: "FlFracassado",
  label: "Fracassado?",
  tdClass: "align-middle",
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const preenchido: TableField = {
  key: "IsLotePreenchido",
  label: "Preenchido?",
  tdClass: ["align-middle", "text-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const participante: TableField = {
  key: "NmParticipante",
  label: "Participante",
  tdClass: ["align-middle", "quebrarPorPalavraHard"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
const qtItens: TableField = {
  key: "QtItens",
  label: "Quantidade de itens",
  tdClass: "align-middle",
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: false,
};
const vlTotalEstimado: TableField = {
  key: "VlTotalEstimado",
  label: "Valor total Est.",
  tdClass: ["align-middle", "text-right"],
  thClass: ["text-right", "quebrarPorPalavraHard"],
  sortable: false,
  formatter: currencyFormatter4Digits,
};
const vlTotalLicitado: TableField = {
  key: "VlTotalLicitado",
  label: "Valor Total Licitado",
  tdClass: ["align-middle", "naoQuebrar"],
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: false,
  formatter: currencyFormatter4Digits,
};
const dtHomologacao: TableField = {
  key: "DtHomologacaoLote",
  label: "Data de Homologação",
  tdClass: "align-middle",
  thClass: ["text-center", "quebrarPorPalavraHard"],
  sortable: false,
  formatter: defaultDateFormatter,
};
export const acoesEdicaoLote: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};
export const acoesEdicaoLoteDinamica: TableField = {
  key: "acoes",
  label: "Ações",
  sortable: false,
  thClass: ["text-center", "naoQuebrar"],
  tdClass: ["text-center", "col-actions", "min7rem"],
};
export const detalhes: TableField = {
  key: "detalhes",
  label: "Ver Itens",
  tdClass: ["align-middle", "w7remLg"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const fieldsLoteLicitacao: TableField[] = [
  sequencial,
  descricao,
  qtItens,
  vlTotalEstimado,
];

export const fieldsVencedoresLicitacaoLote: TableField[] = [
  sequencial,
  descricao,
  preenchido,
  fracassado,
  participante,
  dtHomologacao,
  vlTotalLicitado,
];
